import ActionModelCommon from 'common/models/action';

export default class ActionModel extends ActionModelCommon {}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    action: ActionModel;
  }
}
